const imagesCarousel = {
  backgroundColor: ({ theme }) => theme.colors.greenAlt,
}

export default imagesCarousel
